import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import { Grid } from "@mui/material";
import { useForm, Form } from "../../../../components/Form/FormComponent";
import Controls from "../../../Loyalty/subDealerManagement/subdealer/Controls";
import { RenderCellExpand } from "../../../../components/datagridtooltip/DataGridToolTip";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { AutoCompleteSearchNew } from "../../../../components/SearchBox/AutoCompleteSearchNew";
import {
  DataFormat,
  DATE_FORMAT,
  millisecondsToStringDate,
} from "../../../../_helpers/commonFunctions";
import Axios from "axios";
import { API_URL_LMS, API_URL_ADMIN,API_URL_USER } from "../../../../Constant/index";
// import ExportPopup from "../../../../components/exportPopup/ExportPopup";
import ExportExcelPopup from "../../../../components/exportPopup/ExportExcelPopup";
import DataGridProMUI from "../../../../components/DataGrid/DataGridProMUI";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {
  convertToCurrencyFormat,
  convertToCurrencyFormatQuantaty,
  handleZero,
} from "../../../../_helpers";
import { onExportExcel } from "../../../../_helpers/exportExcel";
import { isPermission, authorizedMessage } from "../../../../_helpers/commonAPI";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },

  container: {
    maxHeight: "calc(90vh - 210px)",
  },

  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

const DEALER_NUMBER = "Dealer Number";
const SUB_DEALER_NUMBER = "Sub Dealer Number";
const BILLING_NUMBER = "Billing Number";
const PRODUCT_NUMBER = "Product Number";

export default function SubDealerActivityTable(props) {
  const classes = useStyles();

  const COMPANY_LIST = [
    // { code: "All", description: "All" },
    { code: "SCCC", description: "SCCC" },
    { code: "CONWOOD", description: "CONWOOD" },
  ];

  const ALLOCATION_TYPE_LIST = [
    // { code: "All", description: "All" },
    { code: "Auto", description: "Auto Allocated" },
    { code: "Manual", description: "Manual Allocated" },
  ];
  const ACTIVITY_TYPE_LIST = [
    // { code: "All", description: "All" },
    { code: "Point Collection", description: "Point Collection" },
    { code: "Point Deduction", description: "Point Deduction" },
    { code: "Redemption", description: "Redemption" },
    { code: "Bonus", description: "Bonus" },
  ];

  const DATE_ONE_YEAR_BACK = new Date(
    new Date().setFullYear(new Date().getFullYear() - 1)
  );
  const INITIAL_STATE = {
    company: "All",
    allocationType: "All",
    activityType: "All",
    startDate: DATE_ONE_YEAR_BACK,
    endDate: new Date(),
    dealerNumber: "",
    subDealerNumber: "",
    billingNumber: "",
    productNumber: "",
  };

  let [filterObj, setFilterObj] = useState(INITIAL_STATE);
  const [filteredData, setFilteredData] = useState([]);
  const [resetCount, setCount] = useState(0);
  const [dealerNumer, setDealerNumer] = useState([]);
  const [subDealerNumber, setSubDealerNumber] = useState([]);
  const [billingNumber, setBillingNumber] = useState([]);
  const [productNumber, setProductNumber] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [gridData, setGridData] = useState([]);
  const [filterErr, setFilterErr] = useState({});
  const [showLoading, setShowLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [exportFiles, setExportFiles] = useState([])
  const [open, setOpen] = useState(false);
  const [exportState, setExportState] = useState("Export");
  const [searchedRows, setSearchedRows] = useState(null)

  const clearAll = () => {
    setFilterObj(INITIAL_STATE);
    setCount((current) => current + 1);
    setFilteredData([]);
    setFilterErr({});
    setValues(INITIAL_STATE);
  };

  const [selectedValue, setSelectedValue] = React.useState(null);
  const excelFormating = [
    { billingDate: "date" },
    { expiryDate: "date" },
    { createDateInMileSecond: "date" },
  ];
  console.log("filterObj", filterObj);

  const filterOnChange = (e) => {
    setFilterErr({});
    setFilterObj({ ...filterObj, [e.target.name]: e.target.value });
  };

  const validate = () => {
    let temp = {};
    if ("endDate" in filterObj && filterObj.endDate != null) {
      temp.startDate =
        filterObj.startDate > filterObj.endDate
          ? "Create Date From Should be lesser than Create Date TO"
          : "";
    }
    setFilterErr({ ...temp });
    return Object.values(temp).every((eachFieldErr) => eachFieldErr === "");
  };

  const { values, setValues, handleInputChange, errors, setErrors } = useForm(
    // INITIAL_FORM_VALUES,
    INITIAL_STATE,
    true,
    validate
  );

  const getdealer = (e) => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };

    Axios.get(
      API_URL_ADMIN + `search/dealerNumberSearch?searchText=${e}`,
      requestOptions
    )
      .then((response) => {
        const dealerSearchDataData =
          response.data &&
          response.data.data &&
          response.data.data.length &&
          response.data.data.map((dealerItem) => {
            return {
              label: dealerItem,
              value: dealerItem,
            };
          });
        setDealerNumer(dealerSearchDataData);
      })
      .catch((error) => {});
  };

  const getSubdealer = (e) => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };

    Axios.get(
      API_URL_ADMIN + `search/subdealerNumberSearch?searchText=${e}`,
      requestOptions
    )
      .then((response) => {
        const subDealerSearchData =
          response.data &&
          response.data.data &&
          response.data.data.length &&
          response.data.data.map((dealerItem) => {
            return {
              label: dealerItem,
              value: dealerItem,
            };
          });
        setSubDealerNumber(subDealerSearchData);
      })
      .catch((error) => {});
  };

  const getBillingNumber = (e) => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };

    Axios.get(
      API_URL_LMS + `admin/billingNumberSearch?searchText=${e}`,
      requestOptions
    )
      .then((response) => {
        const billingData =
          response.data &&
          response.data.data &&
          response.data.data.length &&
          response.data.data.map((dealerItem) => {
            return {
              label: dealerItem,
              value: dealerItem,
            };
          });
        setBillingNumber(billingData);
      })
      .catch((error) => {});
  };

  const getProductNumber = (e) => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };

    Axios.get(
      API_URL_LMS + `admin/productNumberSearch?searchText=${e}`,
      requestOptions
    )
      .then((response) => {
        const productData =
          response.data &&
          response.data.data &&
          response.data.data.length &&
          response.data.data.map((dealerItem) => {
            return {
              label: dealerItem,
              value: dealerItem,
            };
          });
        setProductNumber(productData);
      })
      .catch((error) => {});
  };

  // This Function call on search button click
  // const onFilterSearch = () => {
  //   // check object empty or not
  //   let isEmptyObj = !Object.keys(filterObj).length;
  //   if (isEmptyObj) return 0;

  //   // check object empty or not
  //   const existFilter = removeObjectEmpty(filterObj);
  //   isEmptyObj = !Object.keys(existFilter).length;
  //   if (isEmptyObj) return 0;

  //   // Apply Filter and set row to show list
  //   let filterRows = rows;
  //   if (existFilter.company) {
  //     filterRows = rows.filter((item) => item.company === existFilter.company);
  //   }

  //   if (existFilter.activityType) {
  //     filterRows = filterRows.filter(
  //       (item) => item.activityType === existFilter.activityType
  //     );
  //   }

  //   if (existFilter.allocationType) {
  //     filterRows = filterRows.filter(
  //       (item) => item.allocationType === existFilter.allocationType
  //     );
  //   }

  //   if (existFilter.dealerNumber) {
  //     filterRows = filterRows.filter(
  //       (item) => item.dealerNumber === Number(existFilter.dealerNumber)
  //     );
  //   }

  //   if (existFilter.billingNumber) {
  //     filterRows = filterRows.filter(
  //       (item) => item.billingNumber === Number(existFilter.billingNumber)
  //     );
  //   }

  //   if (existFilter.productNumber) {
  //     filterRows = filterRows.filter(
  //       (item) => item.productNumber === existFilter.productNumber
  //     );
  //   }

  //   if (existFilter.startDate && existFilter.endDate) {
  //     filterRows = filterRows.filter(function (item) {
  //       var itemTime = getDateTime(dateFormater(new Date(item.createdDate)));
  //       var from = getDateTime(dateFormater(new Date(existFilter.startDate)));
  //       var to = getDateTime(dateFormater(new Date(existFilter.endDate)));
  //       return itemTime >= from && itemTime <= to;
  //     });
  //   }
  //   setFilteredData(filterRows);
  // };
  const onFilterSearch = async() => {
    const isAllow = await isPermission("Master-LoyaltyReports-SubDealerActivityPoint-view")
    if (!isAllow) {
        toast.success(authorizedMessage, {
            position: toast.POSITION.TOP_RIGHT
        });
        return 0;
    }
    if (validate()) {
      const requestOptions = {
        headers: {
          "Content-Type": "application/json",
          "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        },
      };
      setShowLoading(true);
      Axios.get(
        API_URL_LMS +
          `admin/activityPointsTransactions?isDealer=${false}&fromDate=${
            filterObj.startDate
              ? moment(filterObj.startDate).format("DD-MM-YYYY").trim()
              : null
          }&toDate=${
            filterObj.endDate
              ? moment(filterObj.endDate).format("DD-MM-YYYY").trim()
              : null
          }&allocationType=${filterObj.allocationType.trim()}&dealerNumber=${
            // filterObj.dealerNumber
            //   ? handleZero(filterObj.dealerNumber).trim()
            //   : null
            values.dealerNumber ? values.dealerNumber : null
          }&subDealerNumber=${
            values.subDealerNumber ? values.subDealerNumber : null
            // filterObj.subDealerNumber.trim() || null
          }&company=${
            filterObj.company === "All" ? null : filterObj.company.trim()
          }&activityType=${
            filterObj.activityType === "All"
              ? null
              : String(filterObj.activityType).trim()
          }&billingNumber=${
            // filterObj.billingNumber.trim() || null
            values.billingNumber ? values.billingNumber : null
          }&productNumber=${
            // filterObj.productNumber.trim() || null
            values.productNumber ? values.productNumber : null
          }&isDealer=${false}&userId=${(
            localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData')).userId) ?
            JSON.parse(localStorage.getItem('userData')).userId : ''}&customer_number=${null}`
            ,
        requestOptions
      )
        .then((response) => {
          setShowLoading(false);
          setFilteredData(
            response.data && response.data.data ? response.data.data : []
          );
        })
        .catch((error) => {
          setShowLoading(false);
          console.log(error);
          // setExportState({ btnName: "EXPORT" });
        });
    }
  };

  function autoSelectFn(selected, name) {
    setFilterObj({
      ...filterObj,
      [name]: selected && selected.value ? selected.value : "",
    });
    // setFilterObj({ ...filterObj, [selected.name]: selected.value });
  }

  const onExportClick=()=>{
    const filters = {
      "company":filterObj.company === "All" ? null : filterObj.company.trim(),
      "activityType":filterObj.activityType === "All"
      ? null
      : String(filterObj.activityType).trim(),
      "dealerNumber":values.dealerNumber ? values.dealerNumber : null,
      "subDealerNumber":values.subDealerNumber ? values.subDealerNumber : null,
      "billingNumber":values.billingNumber ? values.billingNumber : null,
      "productNumber":values.productNumber ? values.productNumber : null,
      "fromDate": filterObj.startDate ? moment(filterObj.startDate).format("DD-MM-YYYY"): null,
      "toDate": filterObj.endDate ? moment(filterObj.endDate).format("DD-MM-YYYY"): null,
      "allocationType" :filterObj.allocationType ? filterObj.allocationType : null,
      "isDealer":false
    }
    const url = `export/sub-dealer-activity/report`;
    setExportState("Exporting...")
    Axios({
        method: "POST",
        url: API_URL_LMS + url,
        data: filters,
        headers: {
            "Content-Type": "application/json",
            "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
            "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
        },
    })
        .then(async (response) => {
            setExportState("Export");
            setOpen(true);
            setFileUrl(response.data.data);
            exportExcelFile(response.data.data);
        })
        .catch((err) => { setExportState("Export");});
}


function exportExcelFile(file_url) {
  setExportFiles([])
  Axios({
      method: "GET", url: API_URL_LMS + `export/bucket?folderName=${file_url}`,
      headers: {
          "Content-Type": "application/json",
          'X-AUTH-TOKEN': localStorage.getItem('x-auth-token'),
          'X-SOLD-TO-ID': localStorage.getItem('CustomerNumber')
      }
  })
      .then(async (response) => {
          const newRes = Array.isArray(response.data.data) ? response.data.data : []
          setExportFiles(newRes)
      }).catch((err) => {
          // setExportState({ btnName: "EXPORT" });
      })
}

  const columns = [
    {
      field: "company",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Company",
    },
    {
      field: "activityType",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Activity Type",
    },
    {
      field: "subDealerId",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Sub Dealer Number",
      renderCell: ({ row }) => {
        return <div>{row.subDealerId ? DataFormat(row.subDealerId) : ""}</div>;
      },
    },
    {
      field: "subDealerName",
      headerAlign: "center",
      align: "left",
      width: 150,
      headerName: "Sub Dealer Name",
      renderCell: RenderCellExpand,
    },
    {
      field: "accountNumber",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Dealer Number",
      renderCell: ({ row }) => {
        return (
          <div>{row.accountNumber ? DataFormat(row.accountNumber) : ""}</div>
        );
      },
    },
    {
      field: "accountName",
      headerAlign: "center",
      align: "left",
      width: 150,
      headerName: "Dealer Name",
      renderCell: RenderCellExpand,
    },
    {
      field: "billingNumber",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Billing Number",
    },
    {
      field: "billingDate",
      headerAlign: "center",
      align: "center",
      width: 100,
      headerName: "Billing Date",
      type: "date",
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    {
      field: "productCode",
      headerAlign: "center",
      align: "center",
      width: 200,
      headerName: "Product Number",
    },
    {
      // mapping productNameEN as in admin portal only Eng is used
      field: "productNameEN",
      headerAlign: "center",
      align: "left",
      width: 200,
      headerName: "Product Name",
      renderCell: RenderCellExpand,
    },
    {
      field: "quantity",
      headerAlign: "center",
      align: "right",
      width: 130,
      headerName: "Quantity (Units)",
      format: '#,##0.000',
      renderCell: ({ row }) => {
        return (
          <div>
            {row.quantity !== null
              ? convertToCurrencyFormatQuantaty(row.quantity)
              : ""}
          </div>
        );
      },
    },
    {
      field: "totalPoints",
      headerAlign: "center",
      align: "right",
      width: 150,
      headerName: "Point Received",
      format: '#,##0.00',
      renderCell: ({ row }) => {
        return (
          <div>
            {row.totalPoints !== null
              ? convertToCurrencyFormat(row.totalPoints)
              : ""}
          </div>
        );
      },
    },
    {
      field: "expiryDate",
      headerAlign: "center",
      align: "center",
      width: 130,
      headerName: "Expiration Date",
      type: "date",
      format: 'DD-MM-yyyy',
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    {
      field: "createDateInMileSecond",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Create Date",
      type: "date",
      format: 'DD-MM-yyyy',
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    {
      field: "remarks",
      headerAlign: "center",
      align: "left",
      width: 150,
      headerName: "Remarks",
      renderCell: RenderCellExpand,
    },
    {
      field: "allocationType",
      headerAlign: "center",
      align: "center",
      width: 150,
      headerName: "Allocation Type",
    },
    { field: 'billDate', headerName: 'billDate', hide: true },
    { field: 'cDate', headerName: 'cDate', hide: true },
    { field: 'exDate', headerName: 'exDate', hide: true },
    { field: 'q', headerName: 'quantity', hide: true },
    { field: 'pr', headerName: 'point received', hide: true },
  ];

  // const CustomToolbar = () => {
  //   return (
  //     <GridToolbarContainer>
  //       <GridToolbarColumnsButton />
  //       <GridToolbarDensitySelector />
  //       <div className="ExportAndSearchContainer">
  //         <Button
  //           variant="outlined"
  //           startIcon={<DownloadIcon />}
  //           onClick={onExportClick}
  //         >
  //           {exportState.btnName}
  //         </Button>
  //       </div>
  //     </GridToolbarContainer>
  //   );
  // };

  React.useEffect(() => {
    const url = `mds/audit-event/create`;
    let details = {
      eventType: "Report_Visit",
      source: "Subdealer Activity Point Report",
      userId: (localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData')).userId) ?
        JSON.parse(localStorage.getItem('userData')).userId : '',
      customer_number: '',
    };

    Axios({
      method: "POST",
      url: API_URL_USER + url,
      data: details,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
      })
      .catch((err) => {
      });
  }, [])

  React.useEffect(() => {
    const gridData =
      filteredData &&
      filteredData.map((item, index) => {
        return {
          ...item,
          // billingDateStr: millisecondsToStringDate(
          //   item.billingDate,
          //   DATE_FORMAT
          // ),
          // expireDateStr: millisecondsToStringDate(item.npm s, DATE_FORMAT),
          billingDate:
            item.billingDate != null ? new Date(item.billingDate) : "",
          expiryDate: item.expiryDate != null ? new Date(item.expiryDate) : "",
          createDateInMileSecond:
            item.billingDate != null
              ? new Date(item.billingDate)
              : new Date(item.createDate),
          // createDateInMileSecond:
          //   item.createDateInMileSecond != null
          //     ? new Date(item.createDateInMileSecond)
          //     : "",
          productName: item.productName != null ? item.productName : "",
          company: item.company != null ? item.company : "",
          activityType: item.activityType != null ? item.activityType : "",
          remarks: item.remarks != null ? item.remarks : "",
          subDealerName: item.subDealerName != null ? item.subDealerName : "",
          accountNumber: item.accountNumber != null ? +item.accountNumber : "",
          accountName: item.accountName != null ? item.accountName : "",
          billingNumber: item.billingNumber != null ? +item.billingNumber : "",
          subDealerId: item.subDealerId != null ? +item.subDealerId : "",
          billDate: item.billingDate != null ? moment(new Date(item.billingDate)).format("DD-MM-yyyy") : "",
          cDate: item.createDateInMileSecond != null ? moment(new Date(item.createDateInMileSecond)).format("DD-MM-yyyy") : "",
          exDate: item.expiryDate != null ? moment(new Date(item.expiryDate)).format("DD-MM-yyyy") : "",
          q: convertToCurrencyFormatQuantaty(item.quantity),
          pr: convertToCurrencyFormat(item.totalPoints)
        };
      });
    setGridData(gridData);
  }, [filteredData]);

  function modifyColumns(columns) {
    columns = columns.filter((item)=>!["actions", "billDate", "cDate", "exDate", "q", "pr"].includes(item.field))
    return columns.map((item) => {
      return ({
        label: item.headerName,
        value: item.field,
        ...item
      })
    })
  }

  function modifyRows(rowdata) {
    // let filteredRow = searchedRows.map((item) => item.model);
    let filteredRow = rowdata.map((item) => item.model);
    const data = filteredRow.map((item) => {
      return ({
        ...item,
        subDealerId: item.subDealerId ? DataFormat(item.subDealerId) : ""
      })
    })
    return data
  }

  function callExcelExport(data){
    const fileName = `SubDealer_Activity_Report_${moment(new Date()).format("DDMMyyyy")}`;
    const sheetName = `SubDealer_Activity_Report`;
    onExportExcel(modifyColumns(columns), modifyRows(data), fileName, sheetName)
  }

  return (
    <>
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <div className="myFirstT mt-1">
            <div className="pCalFormControll">
              <Grid container spacing={2} columns={12}>
                <Grid item sm={6} md={2} xs={12} className="SelectRightPadding">
                  <Controls.Select
                    name="company"
                    label="Company"
                    value={filterObj && filterObj.company}
                    onChange={filterOnChange}
                    optionCode="code"
                    optionLabel="description"
                    options={COMPANY_LIST}
                    minWidth="100%"
                  />
                </Grid>

                <Grid item sm={6} md={2} xs={12} className="SelectRightPadding">
                  <Controls.Select
                    name="activityType"
                    label="Activity Type"
                    value={filterObj && filterObj.activityType}
                    onChange={filterOnChange}
                    optionCode="code"
                    optionLabel="description"
                    options={ACTIVITY_TYPE_LIST}
                    minWidth="100%"
                  />
                </Grid>

                <Grid item sm={6} md={2} xs={12} className="AutoComplete">
                  <Controls.Input
                    name="subDealerNumber"
                    label={SUB_DEALER_NUMBER}
                    value={values.subDealerNumber}
                    onChange={handleInputChange}
                    size="small"
                    variant="standard"
                  />
                  {/* <AutoCompleteSearchNew
                    setSelectedValue={setSelectedValue}
                    inputLabel={SUB_DEALER_NUMBER}
                    name="subDealerNumber"
                    autoSelectFn={autoSelectFn}
                    resetCount={resetCount}
                    OPTIONS_TO_OBJECT={
                      Array.isArray(subDealerNumber) ? subDealerNumber : []
                    }
                    INITIAL_VALUE={filterObj.subDealerNumber}
                    forcePopupIcon={false}
                    callSmartApiFn={(e) => getSubdealer(e)}
                    isSmartSearch={true}
                  /> */}
                </Grid>

                <Grid item sm={6} md={2} xs={12} className="AutoComplete">
                  <Controls.Input
                    name="dealerNumber"
                    label={DEALER_NUMBER}
                    value={values.dealerNumber}
                    onChange={handleInputChange}
                    size="small"
                    variant="standard"
                  />
                  {/* <AutoCompleteSearchNew
                    setSelectedValue={setSelectedValue}
                    inputLabel={DEALER_NUMBER}
                    name="dealerNumber"
                    autoSelectFn={autoSelectFn}
                    resetCount={resetCount}
                    OPTIONS_TO_OBJECT={
                      Array.isArray(dealerNumer) ? dealerNumer : []
                    }
                    INITIAL_VALUE={filterObj.dealerNumber}
                    forcePopupIcon={false}
                    callSmartApiFn={(e) => getdealer(e)}
                    isSmartSearch={true}
                  /> */}
                </Grid>

                <Grid item sm={6} md={2} xs={12} className="AutoComplete">
                  <Controls.Input
                    name="billingNumber"
                    label={BILLING_NUMBER}
                    value={values.billingNumber}
                    onChange={handleInputChange}
                    size="small"
                    variant="standard"
                  />
                  {/* <AutoCompleteSearchNew
                    setSelectedValue={setSelectedValue}
                    inputLabel={BILLING_NUMBER}
                    name="billingNumber"
                    autoSelectFn={autoSelectFn}
                    resetCount={resetCount}
                    OPTIONS_TO_OBJECT={
                      Array.isArray(billingNumber) ? billingNumber : []
                    }
                    INITIAL_VALUE={filterObj.billingNumber}
                    forcePopupIcon={false}
                    callSmartApiFn={(e) => getBillingNumber(e)}
                    isSmartSearch={true}
                  /> */}
                </Grid>

                <Grid item sm={6} md={2} xs={12} className="AutoComplete">
                  <Controls.Input
                    name="productNumber"
                    label={PRODUCT_NUMBER}
                    value={values.productNumber}
                    onChange={handleInputChange}
                    size="small"
                    variant="standard"
                  />
                  {/* <AutoCompleteSearchNew
                    setSelectedValue={setSelectedValue}
                    inputLabel={PRODUCT_NUMBER}
                    name="productNumber"
                    autoSelectFn={autoSelectFn}
                    resetCount={resetCount}
                    OPTIONS_TO_OBJECT={
                      Array.isArray(productNumber) ? productNumber : []
                    }
                    INITIAL_VALUE={filterObj.productNumber}
                    forcePopupIcon={false}
                    callSmartApiFn={(e) => getProductNumber(e)}
                    isSmartSearch={true}
                  /> */}
                </Grid>

                <Grid item sm={6} md={2} xs={12} className="SelectRightPadding">
                  <Controls.DatePicker
                    name="startDate"
                    label="Create Date From"
                    value={
                      filterObj && filterObj.startDate
                        ? filterObj.startDate
                        : DATE_ONE_YEAR_BACK
                    }
                    maxDate={new Date()}
                    onChange={filterOnChange}
                    style={{ width: "100%" }}
                    error={filterErr.startDate}
                  />
                </Grid>
                <Grid item sm={6} md={2} xs={12} className="SelectRightPadding">
                  <Controls.DatePicker
                    name="endDate"
                    label="Create Date To"
                    maxDate={new Date()}
                    value={
                      filterObj && filterObj.endDate
                        ? filterObj.endDate
                        : new Date()
                    }
                    onChange={filterOnChange}
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item sm={6} md={2} xs={12}>
                  <Controls.Select
                    name="allocationType"
                    label="Allocation Type"
                    value={filterObj && filterObj.allocationType}
                    onChange={filterOnChange}
                    optionCode="code"
                    optionLabel="description"
                    options={ALLOCATION_TYPE_LIST}
                    minWidth="100%"
                  />
                </Grid>

                <Grid item md xs display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    className="btncolor"
                    size="small"
                    sx={{ m: 1 }}
                    onClick={onFilterSearch}
                  >
                    Search
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    className="outlineButton"
                    size="small"
                    sx={{ m: 1 }}
                    onClick={clearAll}
                  >
                    Clear All
                  </Button>
                </Grid>
              </Grid>
            </div>

            <div className="DataGridContainer">
            <ExportExcelPopup
                  title={"Customer"}
                  fileName={"customer"}
                  setOpen={setOpen}
                  open={open}
                  exportExcelFile={exportExcelFile}
                  fileUrl={fileUrl}
                  exportFiles={exportFiles}
              />
              <DataGridProMUI
                rows={gridData ? gridData : []}
                columns={columns}
                // components={{
                //   ...(window.innerWidth > 400 && { Toolbar: CustomToolbar }),
                // }}
                localeText={{
                  noRowsLabel: "No reports",
                }}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                loading={showLoading}
                // excelDataTransformConfig={excelDataTransformConfig}
                // ExportDateFormatIndexes={[10]}
                onExportClick={onExportClick}
                exportState={exportState}
                setSearchedRows={setSearchedRows}
                callExcelExport={callExcelExport}
                defaultStateChange={false}
              />
            </div>
          </div>
        </Paper>
      </div>
    </>
  );
}
